import DesignTokens from '@tableau/design-tokens';
import React from 'react';
import _ from 'underscore';

import { applyColor }from '~src/style/ColorService';

import { IContentInfo } from '../../models/IContentInfo';
import { SpacesSiteUrls } from '../spaceComponents/SpacesSiteUrls';
import { TOTAL_CARD_WIDTH } from './CardViewStyles';
import { ContentCardWrapper } from './ContentCardWrapper';


const urls = new SpacesSiteUrls({ siteUrlName: '' });

export interface CardDragPreviewProps {
  readonly content: IContentInfo;
}

export const CardDragPreview = (props: CardDragPreviewProps) => {
  return (
    <div style={{
      backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, 'white'),
      boxShadow: '0 8px 12px 4px '+ applyColor(DesignTokens.color.elevation.surface.default.default, 'rgba(0, 0, 0, 0.15)'),
      width: TOTAL_CARD_WIDTH
    }}>
      <ContentCardWrapper
        addContentFavorite={_.noop}
        content={props.content}
        getContentDetail={_.noop}
        inDatasourceConnectionsSubspace={false}
        allowDragAndDrop={false}
        inProjectSpace={false}
        inRecentsSpace={false}
        inWorkbookDatasourcesSubspace={false}
        removeContentFavorite={_.noop}
        reorderItem={_.noop}
        showActionMenu={true}
        urls={urls}
        forDragPreview={true}
        spaceInfo={undefined}
        dragInProgress={false}
        setIsDragging={_.noop}
        reorderItemAction={_.noop}
      />
    </div>
  );
};

